import {management} from '../../../..'

import {ManagementRepository} from '../../../infra/knex/repositories/management'

import {SaveManagementUseCase} from './saveManagement'

export const saveManagementUseCase=()=>{
  const repository= new ManagementRepository(management)

  const saveManagement= new SaveManagementUseCase(repository)

  return saveManagement
}
